import Vue from 'vue'
import Router from 'vue-router'
//Componentes
import subregistro from '@/components/Subregistro'
//Vistas
import Login from '@/views/Login/Login'
import Payments from '@/views/Payment/Payment'
import Payments2 from '@/views/Payment2'
import Home from '@/views/Home/Home'
import Nosotros from '@/views/Home/Nosotros'
import Empresas from '@/views/Home/Empresas'
import Consultores from '@/views/Home/Consultores'
import Contacto from '@/views/Home/Contacto'
import Faq from '@/views/Home/Faq'
import Planes from '@/views/Home/Planes'
import Registro from '@/views/Registro/Registro'
import Success from '@/views/Success/Success'
import Suscripcion from '@/views/Suscripcion/Suscripcion'
import Perfil from '@/views/Perfil/Perfil'
import Recuperacion from '@/views/Recuperacion/Recuperacion'
import Completaruser from '@/views/Completaruser/Completaruser'
import Pagos from '@/views/Pagos/Pagos'
import Proyectos from '@/views/Proyectos/Proyectos'
import DetalleProyecto from '@/views/DetalleProyecto/DetalleProyecto'
import NuevoProyecto from '@/views/NuevoProyecto/NuevoProyecto'
import Feedback from '@/views/Feedback/Feedback'
import Blog from '@/views/Blogs/Blogs'
import Buscar from '@/views/Buscar/Buscar'
import Calificacion from '@/views/Calificacion/Calificacion'
import EditarProyecto from '@/views/EditarProyecto/EditarProyecto'
import Detalle from '@/views/Detalle/Detalle'
import Propuestas from '@/views/Propuestas/Propuestas'
import Paypal from '@/views/Paypal/Paypal'
import Prueba from '@/views/Prueba/Prueba'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Prueba',
      name: 'Prueba',
      component: Prueba
    },
    {
      path: '/Recuperacion',
      name: 'Recuperacion',
      component: Recuperacion
    },
    {
      path: '/Registro',
      name: 'Registro',
      component: Registro
    },
    {
      path: '/Propuestas/:idEmpresa/:nombre',
      name: 'Propuestas',
      component: Propuestas
    },
    {
      path: '/Detalle/:id',
      name: 'Detalle',
      component: Detalle
    },
    {
      path: '/Payments',
      name: 'Payments',
      component: Payments
    },
    {
      path: '/Payments2',
      name: 'Payments2',
      component: Payments2
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Nosotros',
      name: 'Nosotros',
      component: Nosotros
    },
    {
      path: '/Empresas',
      name: 'Empresas',
      component: Empresas
    },
    {
      path: '/Consultores',
      name: 'Consultores',
      component: Consultores
    },
    {
      path: '/Contacto',
      name: 'Contacto',
      component: Contacto
    },
    {
      path: '/Faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/Planes',
      name: 'Planes',
      component: Planes
    },
    {
      path: '/success',
      name: 'success',
      component: Success
    },
    {
      path: '/suscripcion',
      name: 'suscripcion',
      component: Suscripcion
    },
    {
      path: '/perfil',
      name: 'perfil',
      component: Perfil
    },
    {  
      path: '/pagos',
      name: 'pagos',
      component: Pagos
    },
    {
      path: '/Blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/EditarProyecto/:idProyecto',
      name: 'EditarProyecto',
      component: EditarProyecto
    },
    {
      path: '/Buscar',
      name: 'Buscar',
      component: Buscar
    },
    {
      path: '/NuevoProyecto',
      name: 'NuevoProyecto',
      component: NuevoProyecto
    },
    {
      path: '/subregistro',
      name: 'subregistro',
      component: subregistro
    },
    {
      path: '/completaruser',
      name: 'completaruser',
      component: Completaruser
    },
    {
      path: '/Recuperacion/:token',
      name: 'Recuperacion',
      component: Recuperacion
    },
    {
      path: '/proyectos',
      name: 'proyectos',
      component: Proyectos
    },
    {
      path: '/DetalleProyecto/:idEmpresa',
      name: 'DetalleProyecto',
      component: DetalleProyecto
    },
    {
      path: '/calificacion/:id',
      name: 'calificacion',
      component: Calificacion
    },
    {
      path: '/paypal',
      name: 'paypal',
      component: Paypal
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback
    },
    { path: '*', component: Login }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js